import type { FC } from 'react'
import {
  DateTimeWindowSection,
  FrequencyResultSection,
  ReccurencePatternSection
} from '../sections'
import type { ModalSectionProps, RotaPatternModalType } from '../utils'

export const ReccurenceStep: FC<
  ModalSectionProps & { type?: RotaPatternModalType }
> = ({ formData, setFormData, form, type }) => {
  return (
    <>
      <DateTimeWindowSection
        formData={formData}
        setFormData={setFormData}
        form={form}
      />
      <ReccurencePatternSection formData={formData} setFormData={setFormData} />
      <FrequencyResultSection form={form} type={type} formData={formData} />
    </>
  )
}
